// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"788":"0e81f680","2107":"29d8268b","3016":"8b11cbba","3845":"2b75c2c5","3867":"f60151f9","4617":"fe485248","4715":"74185319","5399":"0e81f680","5525":"3f4bdc54"}[chunkId] + ".chunk.css";
};